import React from "react";
import { Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";

const levelMap: Variant[] = ["h6", "h5", "h4", "h3", "h2", "h1"];

export default function Heading({ level = 3, ...props }) {
  return <Typography variant={levelMap[level]} {...props} />;
}
